import { render, staticRenderFns } from "./assignModal.vue?vue&type=template&id=81de9324&scoped=true"
import script from "./assignModal.vue?vue&type=script&lang=ts"
export * from "./assignModal.vue?vue&type=script&lang=ts"
import style0 from "./assignModal.vue?vue&type=style&index=0&id=81de9324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81de9324",
  null
  
)

export default component.exports